import { connect } from 'react-redux';
import { addContentFavorite, removeContentFavorite } from '../../app/actions/spaces/FavoritesActions';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import {
  PublishedConnectionSpace,
  PublishedConnectionSpaceDispatchProps,
  PublishedConnectionSpaceOwnProps,
  PublishedConnectionSpaceStateProps
} from './PublishedConnectionSpace';

const mapStateToProps: MapStateToProps<PublishedConnectionSpaceStateProps> = (state) => ({
  urls: siteUrlsSelector(state),
});

const mapDispatchToProps: MapDispatchToProps<PublishedConnectionSpaceDispatchProps, PublishedConnectionSpaceOwnProps> = (dispatch, ownProps) => ({
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.publishedConnectionInfo));
  },
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(ownProps.publishedConnectionInfo));
  }
});

export const ConnectedPublishedConnectionSpace = connect(mapStateToProps, mapDispatchToProps)(PublishedConnectionSpace);
